import React from 'react'
import MediaFolders from './MediaFolders'

const MediaLibrary = () => {
  return <MediaFolders />
}

export default MediaLibrary